import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import QRCode from 'qrcode.react';

import config from '../../../../config';

const Back = ({ User, UserMemberShip }) => {
  const qrcodeData = {};
  const { EffectiveEndDate, EffectiveStartDate } = UserMemberShip[0];
  const cardData = { ...User, ...UserMemberShip[0] };

  config.QRCodeInput.forEach(item => {
    qrcodeData[item] = cardData[item];
  });

  const isCardExpired = moment() > moment(EffectiveEndDate);
  const isCardNotStart = moment(EffectiveStartDate) > moment();
  return (
    <svg
      x="0px"
      y="0px"
      width="288px"
      height="186px"
      viewBox="0 0 288 186"
      enableBackground="new 0 0 288 186"
    >
      <rect fill="#A2C1E1" width="288" height="187" />
      <g>
        <rect
          x="5"
          y="5"
          fill="#FFFFFF"
          stroke="#606060"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          width="70"
          height="70"
        />
        <QRCode value={JSON.stringify(qrcodeData)} size={60} x="10" y="10" renderAs="svg" />
      </g>
      <text transform="matrix(1 0 0 1 81.8138 15.5523)" fontFamily="Arial" fontSize="9.0">
        This card is for identification purposes and does{' '}
      </text>
      <text transform="matrix(1 0 0 1 81.8138 27.5523)" fontFamily="Arial" fontSize="9.0">
        not entitle the cardholder to any benefits under the{' '}
      </text>
      <text transform="matrix(1 0 0 1 81.8138 39.5523)" fontFamily="Arial" fontSize="9.0">
        program administered by the State of Arkansas.{' '}
      </text>
      <g>
        <text transform="matrix(1 0 0 1 82.5378 60.8451)" fontFamily="Arial" fontSize="9.0">
          For question concerning your cardholder coverage{' '}
        </text>
        <text transform="matrix(1 0 0 1 82.5378 72.8451)" fontFamily="Arial" fontSize="9.0">
          please call:{' '}
        </text>
      </g>
      <g>
        <text transform="matrix(1 0 0 1 88.9779 159.8284)" fontFamily="Arial" fontSize="11">
          Client Assistance Unit,
        </text>
        <text transform="matrix(1 0 0 1 19.2779 173.8284)" fontFamily="Arial" fontSize="11">
          PO Box 1437, Slot 230 Little Rock, AR 72203-1437
        </text>
      </g>
      <g>
        <text fontFamily="Arial-BoldMT, Arial" fontSize="17" fontWeight="700" y="110" x="137">
          {' '}
          /{' '}
        </text>
        <g>
          <rect x="148" y="90" fill="#a2c1e1" width="132.6" height="26" />
          <text y="110" x="150" fontFamily="Arial-BoldMT, Arial" fontSize="17" fontWeight="700">
            <a href="tel:1-800-482-5431">1-800-482-5431</a>
          </text>
        </g>
        <g>
          <rect x="10" y="90" fill="#a2c1e1" width="126" height="26" />
          <text y="110" x="08" fontFamily="Arial-BoldMT, Arial" fontSize="17" fontWeight="700">
            <a href="tel:1-800-482-8988"> 1-800-482-8988</a>
          </text>
        </g>
      </g>
      <line
        fill="none"
        stroke="#0075B2"
        strokeWidth="1"
        strokeMiterlimit="10"
        x1="0"
        y1="141.7"
        x2="288"
        y2="141.7"
      />
      {(isCardExpired || isCardNotStart) && (
        <rect fill="#FFFFFF" fillOpacity="0.75" width="288" height="186" />
      )}
    </svg>
  );
};

Back.propTypes = {
  User: PropTypes.object.isRequired,
  UserMemberShip: PropTypes.object.isRequired,
};

export default Back;
